module.exports = __webpack_public_path__ + "static/gut-bacteria-eats-6259e37cdac05244d440cdf74dbfc2de.webp";